import { NgModule } from '@angular/core';
import { Routes, RouterModule, Resolve, PreloadAllModules } from '@angular/router';
import { SkeletonComponent, RunReportComponent,AuthCallBackComponent, ErrorComponent, HomeComponent, PageNotFoundComponent } from '../components';
import { AuthGuardService } from '../services';
const routes: Routes = [ 
    {
      path: 'reports/runReport', component: RunReportComponent
    },
    {
      path: 'error', component: ErrorComponent,
      data : {  
        title: 'Error'  
    }  
    }
    ,
    {
      path: 'auth-callback', component: AuthCallBackComponent,
      data : {  
        title: 'Auth Callback'  
      }  
    },
    {
      path: '', component: HomeComponent,canActivate: [AuthGuardService],
    },
 
  {
    path: '', component: SkeletonComponent,canActivate: [AuthGuardService],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('../modules/dashboard.module').then(mod => mod.DashboardModule),
        canActivate: [AuthGuardService],
        data: { roles: ['ADMIN','BOM','BSS','BSSX','BOMX'],title:"Dashboard" } 
        
      },
      {
        path: 'tickets',
        loadChildren: () => import('../modules/tickets.module').then(mod => mod.TicketsModule),
        canActivate: [AuthGuardService],
        data: { roles: ['ADMIN','BOM','BSS','BSSX','BOMX'],title:"Ticket" } 
      },
      {
        path: 'equipment',
        loadChildren: () => import('../modules/equipment.module').then(mod => mod.EquipmentModule),
        canActivate: [AuthGuardService],
        data: { roles: ['ADMIN','BOM','BSS','ANALYST','HHD','BSSX','BOMX'] ,title: 'Equipment Search'} 
      },
      {
        path: 'administrator',
        loadChildren: () => import('../modules/administrator.module').then(mod => mod.AdministratorModule),
        canActivate: [AuthGuardService],
        data: { roles: ['ADMIN','BOM','BOMX'],title: 'Service Request'  } 
      },
      {
        path: 'reports',
        loadChildren: () => import('../modules/report.module').then(mod => mod.ReportModule),
        canActivate: [AuthGuardService],
        data :
         {  
          roles: ['*'],
          title: 'Reports'  
         }  
      }
      ,
      {
        path: 'settings',
        loadChildren: () => import('../modules/setting.module').then(mod => mod.SettingModule),
        canActivate: [AuthGuardService],
        data: { roles: ['ADMIN','BOM','BSS','ANALYST','HHD','BSSX','BOMX','CLN','CLNX','CLNSX','CLNLNX','LNX'],title: 'Settings'} 
      },	// FREQ-685039 Role-based Entitlements
      {
        path: 'ServiceRequest',
        loadChildren: () => import('../modules/systemx.module').then(mod => mod.SystemxModule),
        canActivate: [AuthGuardService],
        data: { roles: ['ADMIN','CLN','CLNX','BSSX','CLNSX','BOMX','CLNLNX','LNX'] ,title: 'Service Request'} 
        
      },
      {
        path: 'WaterLab',
        loadChildren: () => import('../modules/water-lab.module').then(mod => mod.WaterLabModule),
        canActivate: [AuthGuardService],
        data: { roles: ['ADMIN','FA','LCU','UCU','HHD','BSS','BOM'],title:"Water Lab" }
      },	// FREQ-685039 Role-based Entitlements
    ],
  },
  {path: '404', component: PageNotFoundComponent},
  {path: '**', redirectTo: '/404'}
  
  

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false, preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
